import React, { useState } from "react";
import "./Tabs.css";
// import Filter from "./Filter";

const Tabs = ({
  tabs,
  filters,
  onTabChange,
  showCheckboxes,
  showFilter,
  className,
  count,
  selectedTab,
  nextActiveTab,
}) => {
  
  const [activeTab, setActiveTab] = useState(
    tabs && tabs.length > 0 ? tabs[0].value : ""
  );
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    onTabChange(tabName); // Notify the parent component about the tab change
  };

  return (
    <div className="tabs-container">
      {tabs && tabs.length > 0 && (
        <div className="tab-buttons ">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              className={`tab-button ${(tab.value===selectedTab) ||(activeTab===tab.value && nextActiveTab !=="1")? "active" : ""} ${className}`}
              onClick={() => handleTabClick(tab.value)}
            >
              {["All", "Followups","Hot","Booked","Funnel"].includes(tab.label) ? (
                <p>
                  {tab.label} ({count})
                </p>
              ) : (
                <p>{tab.label}</p>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Tabs;
